import { useState, useEffect, useCallback } from 'react';

interface NetworkStatus {
  isOnline: boolean;
  wasOffline: boolean;
  effectiveType: string | null;
}

export function useNetworkStatus(): NetworkStatus {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  const getEffectiveType = useCallback((): string | null => {
    const nav = navigator as any;
    return nav.connection?.effectiveType ?? null;
  }, []);

  const [effectiveType, setEffectiveType] = useState<string | null>(getEffectiveType);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setEffectiveType(getEffectiveType());
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const nav = navigator as any;
    nav.connection?.addEventListener('change', () => {
      setEffectiveType(getEffectiveType());
    });

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [getEffectiveType]);

  return { isOnline, wasOffline, effectiveType };
}
